import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_AOuQ1DYzjk from "/app/node_modules/@sidebase/nuxt-auth/dist/runtime/plugin.mjs";
import composition_sLxaNGmlSL from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import _02_service_registry_8S88WR7aXN from "/app/modules/common/plugins/02.service-registry.ts";
import _01_global_components_IJ4rw82UPX from "/app/plugins/01.global-components.ts";
import _02_service_registry_BdHn9LkV7C from "/app/plugins/02.service-registry.ts";
import _03_store_inititalizer_vvspetV4o0 from "/app/plugins/03.store-inititalizer.ts";
import _10_matomo_plugin_client_msU8svHAfy from "/app/plugins/10.matomo-plugin.client.ts";
import _03_initialize_store_pB7kwLDFU9 from "/app/modules/common/plugins/03.initialize-store.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_AOuQ1DYzjk,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  _02_service_registry_8S88WR7aXN,
  _01_global_components_IJ4rw82UPX,
  _02_service_registry_BdHn9LkV7C,
  _03_store_inititalizer_vvspetV4o0,
  _10_matomo_plugin_client_msU8svHAfy,
  _03_initialize_store_pB7kwLDFU9
]